import { useCallback, useMemo, useState } from 'react'
import { useGetProfessinals } from '../../queries/ScheduleAppointment/Telemedicine.queries'
import useScheduleAppointmentStore from '../../store/ScheduleAppointment/ScheduleAppointment'
import { useNavigate } from 'react-router-dom'
import { PROFESSIONALS_PER_PAGE } from '../ProfessionalAppointment/components/PsychologistCard/constants'
import { ProfessionalFilterMapper } from '../../services/mapper/ProfessionalsMapper/ProfessionalsMapper'

export const useProfessionalSearch = () => {
  const navigate = useNavigate()

  const [page, setPage] = useState(1)

  const updateValue = useScheduleAppointmentStore(state => state.updateValue)
  const { dataFormatted, theoreticalApproachData, themesData } =
    useScheduleAppointmentStore()

  const { data: professionals, isLoading } = useGetProfessinals(
    dataFormatted?.clinicId,
    {
      ...ProfessionalFilterMapper.toPersistence(dataFormatted),
      page,
      approachIds: theoreticalApproachData?.id?.toString(),
      themeIds: themesData?.id?.toString(),
      limit: PROFESSIONALS_PER_PAGE,
      patientId: dataFormatted?.patient?.patientId,
    },
  )

  const handleNewProfessionalSearch = useCallback(() => {
    updateValue('persistDataForm', true)
    updateValue('themesData', null)
    updateValue('theoreticalApproachData', null)
    navigate('/atendimento/agendar/consulta')
  }, [navigate, updateValue])

  const showPagination = useMemo(() => {
    return professionals?.total > 2 && !isLoading
  }, [isLoading, professionals?.total])

  const showNoResults = useMemo(() => {
    return !isLoading && professionals?.items?.length === 0
  }, [isLoading, professionals?.items?.length])

  const professionalsPaginationCount = useMemo(
    () => Math.ceil(professionals?.total / PROFESSIONALS_PER_PAGE) || 1,
    [professionals?.total],
  )

  const handleChangePage = useCallback((newPage: number) => {
    setPage(newPage)
  }, [])

  return {
    isLoading,
    professionals,
    page,
    professionalsPaginationCount,
    showPagination,
    showNoResults,
    handleNewProfessionalSearch,
    handleChangePage,
  }
}
